module.exports = __webpack_public_path__ + "static/media/bitmap@2x.13cd3d1c.jpg";